import type { LoginLocale } from "@/locales/fr/login";

const loginLocale: LoginLocale = {
  login: {
    login: "Connect",
    username: "Username",
    password: "Password",
    welcome: "Welcome",
    connectToYourAccount: "Connect to your account",
    logout: "Log out",
  },
};

export default loginLocale;
